import './BrandedLoader.css'

function BrandedLoader() {
	return (
		<div className='brandedLoader' role='status' aria-live='polite'>
			<div className='brandedLogo' aria-hidden='true' />
			<div className='brandedSpinner' aria-hidden='true' />
			<p>Chargement...</p>
		</div>
	)
}

export default BrandedLoader
